import { useCallback, KeyboardEvent } from 'react';

export interface IUseOnKeyDownHandlerProps {
  suggestPart: string;
  inputValue: string;
  handleOnChange(value: string): void;
}
export const useOnKeyDownHandler = (props: IUseOnKeyDownHandlerProps) => {
  const { handleOnChange, inputValue, suggestPart } = props;

  return useCallback(
    (e: KeyboardEvent) => {
      if (e.key === 'Tab' && suggestPart) {
        e.preventDefault();
        handleOnChange(inputValue + suggestPart);
      }
    },
    [suggestPart, inputValue, handleOnChange],
  );
};
